import { useCallback, useEffect, useRef } from "react";
const DEFAULT_SCROLL_TO = {
    yOffset: -80
};
export function useScrollTo(props) {
    const scrollWrapper = useRef(null);
    const scrollTo = useCallback(function() {
        let options = arguments.length > 0 && arguments[0] !== void 0 ? arguments[0] : DEFAULT_SCROLL_TO;
        if (!scrollWrapper.current) return;
        const y = scrollWrapper.current.getBoundingClientRect().top + window.pageYOffset + options.yOffset;
        window.scrollTo({
            top: y,
            behavior: "smooth"
        });
    }, [
        props.id
    ]);
    const queryElement = ()=>{
        const element = document.querySelector("#".concat(props.id));
        if (!element) throw new Error("Scroll wrapper not found");
        return element;
    };
    useEffect(()=>{
        scrollWrapper.current = queryElement();
    }, []);
    return {
        element: scrollWrapper.current,
        scrollTo
    };
}
